var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"introduction"},_vm._l((_vm.infos),function(item,index){return _c('p',{key:index,staticClass:"row",on:{"click":_vm.handleGo}},[_c('span',{staticClass:"img-box"},[_c('img',{attrs:{"src":item.url,"alt":""}})]),_c('span',{staticClass:"name"},[_vm._v(_vm._s(item.name))])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }